import { render, staticRenderFns } from "./ImptBsnesAgencInfo.vue?vue&type=template&id=dd2b45a2&scoped=true"
import script from "./ImptBsnesAgencInfo.vue?vue&type=script&lang=js"
export * from "./ImptBsnesAgencInfo.vue?vue&type=script&lang=js"
import style0 from "./ImptBsnesAgencInfo.vue?vue&type=style&index=0&id=dd2b45a2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2b45a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd2b45a2')) {
      api.createRecord('dd2b45a2', component.options)
    } else {
      api.reload('dd2b45a2', component.options)
    }
    module.hot.accept("./ImptBsnesAgencInfo.vue?vue&type=template&id=dd2b45a2&scoped=true", function () {
      api.rerender('dd2b45a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/ImptBsnesAgencInfo.vue"
export default component.exports